import { render, staticRenderFns } from "./recommendAddress.vue?vue&type=template&id=4046285e&scoped=true&"
import script from "./recommendAddress.vue?vue&type=script&lang=js&"
export * from "./recommendAddress.vue?vue&type=script&lang=js&"
import style0 from "./recommendAddress.vue?vue&type=style&index=0&id=4046285e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4046285e",
  null
  
)

export default component.exports